import { combineReducers } from '@reduxjs/toolkit'

import authReducer from '../features/authentication/authSlices'
import userReducer from '../features/authentication/userSlices'
import profileReducer from '../features/profile/profileSlices'
import shopReducer from '../features/profile/shopSlices'
import productSlice from '../features/profile/productSlices'

const store = combineReducers({
  auth: authReducer,
  user: userReducer,
  profile: profileReducer,
  shop: shopReducer,
  product: productSlice
})

export default store